import endpoints from './endpoints';
import axiosApiInstance from './axios.interceptor'

class UploadFilesService {

    constructor() { }

    getFolioSeim(tipo_documento_seim) {
        const config = {
            params: {
                tipo_documento_seim: tipo_documento_seim
            }
        }
        return axiosApiInstance.get(endpoints.backend.get_folio_seim, config)
    }

    upload(file, folio_documento=null, tipo_documento_seim=null) {
        const formData = new FormData();
        formData.append(
            "file",
            file,
            file.name
        );
        formData.append("folio_documento", folio_documento)
        formData.append("tipo_documento_seim", tipo_documento_seim)
        return axiosApiInstance.post(endpoints.backend.uploadfile, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
    }
    
    generatePdfDocument(ficha_id, template, content) {
        return axiosApiInstance.post(endpoints.backend.evaluacionImiv+'generate-pdf', {
            template,
            content,
            ficha_id,
            preview: false
        }, {
            responseType: 'blob',
            validateStatus: status => status < 500  // Accept responses with status code < 500
        }).then(response => {
            // If not a PDF (when there's an error), convert the response to JSON
            if (response.status !== 200 || response.headers['content-type'] !== 'application/pdf') {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => {
                        try {
                            const errorJson = JSON.parse(reader.result);
                            response.data = errorJson;
                            reject({ response });
                        } catch (e) {
                            // If it can't be parsed as JSON, keep the blob
                            reject({ response });
                        }
                    };
                    reader.onerror = () => reject({ response });
                    reader.readAsText(response.data);
                });
            }
            return response;
        });
    }

}

export default UploadFilesService;
